function importAllImages(r) {
    let images = {};
    r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
    return images
}

// Import each bundled asset format used by the public site. WebP screenshots are
// emitted as build assets, so they do not rely on a hosting rewrite rule.
const images = importAllImages(require.context('../assets', true, /\.(png|jpg|webp|svg|mp4)$/));

export default images;
